import _get from 'lodash/get';

export const segregateClientLists = lists => {
  const belowFeatureList = [];
  const aboveFeatureList = [];
  // eslint-disable-next-line no-restricted-syntax
  for (const list of lists) {
    if (_get(list, 'displaySection', '') === 'Below Featured Lists') {
      belowFeatureList.push(list);
    } else {
      aboveFeatureList.push(list);
    }
  }
  return { belowFeatureList, aboveFeatureList };
};
